<template>
  <div class="container">
    <div
      class="card mb-2"
      v-if="successfulEntries !== null"
      style="background: #B8F2A5; color: #000;"
    >
      <div class="card-body">
        <div class="d-flex m-1 align-items-center">
          {{ successfulEntries.length }}
          {{
            successfulEntries.length === 1 ? "activity was" : "activities were"
          }}
          created: &nbsp;
          <a
            :href="
              'https://secure.medicalalley.org/np/admin/contact/activityDetail.do?id=' +
                entry.id
            "
            class="badge badge-success m-1"
            v-for="entry in successfulEntries"
            :key="entry.id"
            target="_blank"
          >
            Activity #{{ entry.id }}
          </a>
        </div>
        <div
          class="text-center"
          @click="successfulEntries = null"
          style="cursor: pointer; font-size: 0.8em;"
        >
          [CLOSE]
        </div>
      </div>
    </div>
    <div class="maadi-dark-card">
      <div v-if="!isProcessing" class="card-body">
        <div class="text-center">
          <h1>Activity Creator Form</h1>
        </div>
        <div class="p-2 text-center" style="font-size: 1em; font-weight: 300">
          This form creates the same activity across multiple accounts. Use
          ‘Select an Account’ to find and select the appropriate accounts.
        </div>
        <div v-if="errorMessage !== null" style="color: firebrick">
          {{ errorMessage }}
        </div>
        <hr />
        <!-- ACCOUNTS -->
        <div class="pb-2 p-1">
          <div class="field-name">Accounts in Activity</div>
          <account-selector
            v-on:selectedAccount="
              e => {
                selectedAccount(e);
              }
            "
            style="color: #000;"
          ></account-selector>
        </div>
        <div class="pb-2 p-1" v-if="activity.selectedAccounts.length > 0">
          Selected Accounts
        </div>
        <div
          class="d-flex p-2 mb-2"
          v-for="account in activity.selectedAccounts"
          :key="account.account_id"
          style="border: solid 1px #ddd; border-radius: 5px"
        >
          <div class="d-flex align-items-center justify-content-center p-2">
            <i
              v-if="account.account_type === 'Individual'"
              class="fas fa-user"
            ></i>
            <i
              v-if="account.account_type === 'Organization'"
              class="fas fa-building"
            ></i>
          </div>
          <div class="d-flex flex-fill flex-column p-2">
            <div>{{ account.name }}</div>
            <div
              v-if="account.account_type === 'Individual'"
              style="font-weight: 300"
            >
              <b>{{ account.organization_name }}</b> - {{ account.job_title }}
            </div>
          </div>
          <div class="d-flex align-items-center justify-content-center p-2">
            <a
              v-on:click="removeAccount(account.account_id)"
              style="cursor: pointer"
              ><i class="fas fa-times"></i
            ></a>
          </div>
        </div>
        <!-- ACTIVITY FIELDS -->
        <div class="pb-2 p-1">
          <div class="field-name">
            Subject
            <i
              class="fas fa-question-circle"
              v-b-tooltip.hover
              title="Please make your subject as detailed as possible."
            ></i>
          </div>
          <b-form-input
            id="activity-subject"
            v-model="activity.subject"
          ></b-form-input>
        </div>
        <div class="pb-2 p-1">
          <div>
            <div class="field-name">Note</div>
            <b-form-textarea
              id="activity-note"
              type="textarea"
              placeholder="Enter activity note"
              rows="3"
              max-rows="25"
              v-model="activity.note"
            ></b-form-textarea>
          </div>
        </div>
        <div class="d-flex pb-2">
          <div class="p-1 flex-fill">
            <div class="field-name">
              Activity Date
              <i
                class="fas fa-question-circle"
                v-b-tooltip.hover
                title="Please use the date the activity happened"
              ></i>
            </div>
            <b-form-input
              id="activity-start-date"
              type="date"
              v-model="activity.start_date"
            ></b-form-input>
          </div>
          <div class="p-1 flex-fill">
            <div class="field-name">Type</div>
            <b-form-select
              v-model="activity.type"
              :options="activityTypeMapping"
            ></b-form-select>
          </div>
          <div class="p-1 flex-fill" v-if="false">
            <div class="field-name">Subtype</div>
            <b-form-select
              v-model="activity.sub_type"
              :options="activitySubTypeMapping"
            ></b-form-select>
          </div>
          <div class="p-1 flex-fill">
            <div class="field-name">Initiative Type</div>
            <b-form-select
              v-model="activity.initiative_type"
              :options="initiativeTypes"
            ></b-form-select>
          </div>
        </div>
        <div class="d-flex align-items-center justify-content-center mt-4">
          <div>
            <button
              v-on:click="submitActivity"
              type="submit"
              class="btn maadi-button"
            >
              Submit
            </button>
          </div>
        </div>
      </div>
      <div v-if="isProcessing" class="card-body">
        <div class="text-center">
          <b-spinner variant="danger" type="grow" label="Spinning"></b-spinner>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AccountSelector from "../tools/AccountSelector";
import ActivityAPI from "../../api/activity";
import API from "../../api/index";
import ActivityConstants from "./ActivityConstants";

export default {
  name: "",
  components: { AccountSelector },
  computed: {
    activityTypeMapping() {
      let activityTypes = [];
      ActivityConstants.activityMapping.forEach(x => {
        activityTypes.push(x.type);
      });
      return activityTypes;
    },
    activitySubTypeMapping() {
      if (this.activity.type === null) {
        return [];
      }
      let activityTypeObject = ActivityConstants.activityMapping.filter(
        x => x.type === this.activity.type
      );
      return activityTypeObject[0].subTypes;
    }
  },
  data: function() {
    return {
      isProcessing: false,
      paramVariables: {
        accountID: null,
        redirectURL: null
      },
      errorMessage: null,
      successfulEntries: null,
      activityType: [
        { text: "", value: null },
        { text: "Meeting", value: "Meeting" },
        { text: "Referrals", value: "Referrals" },
        { text: "Renewals", value: "Renewals" },
        { text: "Advocacy ", value: "Advocacy" },
        { text: "Invitation", value: "Invite" },
        { text: "Testimonial", value: "Testimonial" },
        { text: "Content", value: "Content" },
        { text: "Sponsorship", value: "Sponsorship" },
        { text: "COVID-19", value: "COVID-19" }
      ],
      initiativeTypes: [
        { text: "", value: null },
        { text: "Health Equity", value: "Health Equity" },
        { text: "HR & Talent", value: "HR & Talent" },
        { text: "International Efforts", value: "International Efforts" },
        { text: "Medical Alley Starts", value: "Medical Alley Starts" },
        { text: "Supply Chain", value: "Supply Chain" }
      ],
      activity: {
        selectedAccounts: [],
        subject: "",
        note: "",
        start_date: new Date().toISOString().slice(0, 10),
        status: "Completed",
        priority: "Normal",
        type: null,
        initiative_type: null,
        reminder_date: null
      }
    };
  },
  methods: {
    selectedAccount: function(e) {
      this.activity.selectedAccounts.push(e);
    },
    removeAccount: function(e) {
      this.activity.selectedAccounts = this.activity.selectedAccounts.filter(
        function(x) {
          return x.account_id !== e;
        }
      );
    },
    verifyModel: function() {
      if (this.activity.selectedAccounts.length === 0) {
        this.errorMessage = "Must select an account.";
      }
      if (this.activity.subject === "" && this.activity.type === null) {
        this.errorMessage = "Must set a subject or type.";
      }
      if (this.activity.note === "") {
        this.errorMessage = "Must set a note.";
      }
      return this.errorMessage === null;
    },
    submitActivity: function() {
      this.errorMessage = null;
      if (this.verifyModel()) {
        this.isProcessing = true;
        ActivityAPI.createActivity(this.activity).then(result => {
          this.isProcessing = false;
          if (result.data.success) {
            this.successfulEntries = result.data.created;
            this.activity = {
              selectedAccounts: [],
              subject: "",
              note: "",
              start_date: new Date().toISOString().slice(0, 10),
              status: "Completed",
              priority: "Normal",
              type: null,
              initiative_type: null,
              reminder_date: null
            };
          } else {
            this.errorMessage = "There was an error: " + result.data.message;
          }
        });
      }
    }
  },
  mounted() {
    if ("account_ids" in this.$route.query) {
      API.getAutocompleteAccountV2(this.$route.query).then(response => {
        this.activity.selectedAccounts = response.data;
      });
    }
  }
};
</script>

<style scoped>
textarea {
  border-radius: 0;
}
.field-name {
  font-weight: 300;
  text-transform: uppercase;
  font-size: 0.8em;
}
</style>



// WEBPACK FOOTER //
// src/components/activities/ActivityForm.vue